import { observable, action } from "mobx";

class Filter {
  @observable value = {};
  @observable url = '';

  @action setFilter = filterData => {
    this.value = filterData;
  };

  @action clearFilter = () => {
    this.value = {}
    this.url = ''
  }

  @action setFilterUrl = (url) => {
    this.url = url
  }

}

export default new Filter();



// WEBPACK FOOTER //
// ./src/stores/Filter.js